<template>
  <div class="checkupdetail">
    <div class="card-box">
      <div class="title">
        {{ data.checkupItem }}
      </div>
      <div class="row mb24">
        <span>报告单号：</span>
        <span>{{ bgdh }}</span>
      </div>
      <div class="row mb24">
        <span>报告类型：</span>
        <span>{{ data.checkupType }}</span>
      </div>
      <div class="row mb24">
        <div class="left">
          <span>姓名：</span>
          <span>{{ data.patName }}</span>
        </div>
        <div>
          <span>性别：</span>
          <span>{{ data.sex }}</span>
        </div>
      </div>
      <div class="row mb24">
        <div class="left">
          <span>年龄：</span>
          <span>{{ data.age }}</span>
        </div>
        <div>
          <span>科室：</span>
          <span>{{ data.applyDeptName }}</span>
        </div>
      </div>
      <!-- <div class="row mb24">
        <span>就诊卡号：</span>
        <span>{{ data.jzkh }}</span>
      </div> -->
      <div v-if="data.source==='2'" class="row mb24">
        <div class="left">
          <span>病区：</span>
          <span>{{ data.ward }}</span>
        </div>
        <div>
          <span>床号：</span>
          <span>{{ data.bedNumber }} </span>
        </div>
      </div>
      <div class="row mb24">
        <div class="left">
          <span>申请医师：</span>
          <span>{{ data.applyDocName }}</span>
        </div>
        <div>
          <span>检查医师：</span>
          <span>{{ data.checkupDocName }}</span>
        </div>
      </div>
      <div class="row mb24">
        <span>检查日期：</span>
        <span>{{ data.checkupTime }}</span>
      </div>
      <div class="row">
        <span>报告医师：</span>
        <span>{{ data.reportDocName }}</span>
      </div>
    </div>
    <div class="card-box">
      <div class="title">
        部位:
      </div>
      <div class="row">
        {{ data.checkupPosition }}
      </div>
    </div>
    <div class="card-box">
      <div class="title">
        检查所见:
      </div>
      <div class="row">
        {{ data.checkupFind }}
      </div>
    </div>
    <div class="card-box">
      <div class="title">
        检查结论:
      </div>
      <div class="row">
        {{ data.checkupConclusion }}
      </div>
    </div>
    <!-- <div v-for="(item, index) in data.listJcReport" :key="index" class="card-box">
      <div class="title">
        {{ item.jclb }}:
      </div>
      <div class="row">
        {{ item.jg }}
      </div>
    </div> -->
  </div>
</template>

<script>
import {patientModel} from "../../../api/patient"
export default {
  name:'CheckupDetail',
  data() {
    return {
      data:{},
      bgdh:this.$route.query.bgdh
    }
  },
  mounted(){
    this.loadData()
  },
  methods:{
    loadData(){
      let params={
        patientId: this.$route.query.patId ||'',
        checkupNo: this.$route.query.bgdh ||''
        // patxm: this.$route.query.patxm ||''
        // zjh: this.$route.query.zjh ||''
      }
      patientModel.checkupDetail(params).then(res=>{
        this.data = res.data
      })
    }
  }
}
</script>

<style scoped lang='less'>
@import "../../../assets/styles/variable.less";

.checkupdetail {
    padding: 32px;

    .card-box {
        width: 100%;
        background: #FFFFFF;
        border-radius: 12px;
        margin-bottom: 24px;
        padding: 32px;
        box-sizing: border-box;

        .title {
            font-size: 32px;
            font-weight: bold;
            color: #3D3D3D;
            line-height: 45px;
            margin-bottom: 32px;
        }

        .row {
            display: flex;
            line-height: 40px;
            font-size: 28px;
            // margin-bottom: 24px;
            color: #666666;

            .left {
                text-align: left;
                width: 325px;
            }
        }

        .mb24 {
            margin-bottom: 24px;
        }
    }
}
</style>
